var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 17 14',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Account-Popup',
        transform: 'translate(-1104.000000, -197.000000)',
        stroke: '#323232',
        strokeWidth: '2'
    }, React.createElement('g', {
        id: 'Account-Menu',
        transform: 'translate(1091.000000, 80.000000)'
    }, React.createElement('g', {
        id: 'Share-Icon-Copy',
        transform: 'translate(8.000000, 112.000000)'
    }, React.createElement('path', {
        d: 'M16.5,8.44125 L20,12.00025 L16.5,15.55875',
        id: 'Path-Copy-2'
    }), React.createElement('path', {
        d: 'M9,12.0003833 L19.2333333,12.0003833',
        id: 'Path-Copy'
    }), React.createElement('path', {
        d: 'M12.5,8.5 L15.5,8.5 L15.5,15.5 L3.5,15.5 L3.5,8.5 L6.5,8.5',
        id: 'Path-184',
        transform: 'translate(9.500000, 12.000000) rotate(-270.000000) translate(-9.500000, -12.000000) '
    }))))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Exit.svg
// module id = 526
// module chunks = 1